export const baseUrl = "https://hrm.rsh.im/api/website/";
export const baseApi = "https://hrm.rsh.im/api/";
export const imageUrl = "https://hrm.rsh.im";
// export const baseUrl = "http://127.0.0.1:8000/api/website/";
